"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderNormalizer = void 0;
/**
 * normalizador del modulo MODULO_CARACTERISTIC_CARDS
 * @param {object} fields
 * @returns
 */
const orderNormalizer = (data) => {
    let res = null;
    try {
        if (data) {
            const { fields } = data;
            const { orderList } = fields;
            if (orderList && Array.isArray(orderList)) {
                res = [];
                const moduleNames = [];
                const countName = [];
                orderList.sort((a, b) => parseInt(a.moduleOrder, 10) - parseInt(b.moduleOrder, 10));
                orderList.forEach((fila) => {
                    const module = fila.fields;
                    if (module && module.moduleOrder) {
                        const { moduleOrder, nameModule, idModule, hidden } = module;
                        if (countName[nameModule]) {
                            countName[nameModule]++;
                        }
                        else {
                            countName[nameModule] = 1;
                        }
                        let finalName = nameModule;
                        if (countName[nameModule] > 1) {
                            finalName = `${nameModule}-|-${countName[nameModule]}`;
                        }
                        res.push({
                            moduleOrder,
                            nameModule: finalName,
                            idModule,
                            hidden: hidden === "true" || hidden === true
                        });
                        moduleNames.push(nameModule);
                    }
                });
            }
        }
        return res;
    }
    catch (error) {
        console.error(error);
        return null;
    }
};
exports.orderNormalizer = orderNormalizer;
exports.default = exports.orderNormalizer;
//# sourceMappingURL=index.js.map